import { modals } from "@mantine/modals";
import DataTable from "../../components/common/DataTable";
import { Button, Modal } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Head from "../../components/common/Head";
import CustomInput from "../../components/common/Input";
import useValidate from "../../hooks/useValidate";
import {
  addCategory,
  deleteCategory,
  getAllCategories,
  updateCategory,
} from "../../utils/api";
import useStore from "../../utils/store";

const Categories = () => {
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const [categories, setCategories] = React.useState([]);
  
  const [modal, setModal] = React.useState(false);
  const [update, setUpdate] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loading3, setLoading3] = React.useState(false);
  const [buttonloading, setButtonLoading] = React.useState(false);
  const [newCategory, setNewCategory] = React.useState({});

  const getAllCategoriesData = async () => {
    setLoading(true);
    const [success, response] = await getAllCategories();
    if (success) setCategories(response);
    setLoading(false);
  };

  const deleteCategoryData = async (id) => {
    setLoading(true);
    const [success, response] = await deleteCategory(id);
    if (success) {
      notifications.show({ message: "Category deleted successfully", color: "green" });
      getAllCategoriesData();
    }
    setLoading(false);
  };

  const createNewCategory = async () => {
    if (!newCategory.name || !newCategory.position)
      return notifications.show({ message: "Please fill all the fields", color: "red" });
    setButtonLoading(true);
    if (!update) {
      const [success, response] = await addCategory(newCategory);
      if (success) {
        notifications.show({ message: "Category added successfully", color: "green" });
        setModal(false);
        getAllCategoriesData();
      }
    } else {
      const [success, response] = await updateCategory(update, newCategory);
      if (success) {
        notifications.show({ message: "Category updated successfully", color: "green" });
        setUpdate(null);
        setModal(false);
        getAllCategoriesData();
      }
    }
    setNewCategory({});
    setButtonLoading(false);
  };
  useValidate();
  useEffect(() => {
    getAllCategoriesData();
  }, []);
  return (
    <>
      
      <Head
        title="Categories"
        customButton={
          user?.addCategory ? (
            <Link to="/categories/add">
              <Button>Add </Button>
            </Link>
          ) : null
        }
      />
      {user?.getAllCategories && (
        <DataTable
          scroll={{
            x: 500,
          }}
          dataSource={categories}
          loading={loading}
          columns={[
            {
              title: "Name",
              dataIndex: "name",
              key: "name",
            },
            {
              title: "Position",
              dataIndex: "position",
              key: "position",
            },
            {
              title: "Sub Categories",
              dataIndex: "subcategories",
              key: "subcategories",
              render: (text, record) =>
                user?.getAllSubcategories && (
                  <Button
                    onClick={() => {
                      navigate(`/subcategories/${record._id}/${record.name}`);
                    }}
                  >
                    Sub-Categories
                  </Button>
                ),
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              render: (text, record) => (
                <div className="row">
                  {user?.updateCategory && (
                    <Link to={`/categories/edit/${record._id}`}>
                      <Button>Edit</Button>
                    </Link>
                  )}

                  {user?.deleteCategory && (
                    <Button color="red"
                      variant="filled"
                      onClick={() => {
                        modals.openConfirmModal({
                          title:
                            "Are you sure you want to delete this category?",
                          onConfirm: () => {
                            deleteCategoryData(record._id);
                          },
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}
                </div>
              ),
            },
          ]}
        />
      )}
      <Modal
        opened={modal}
        onClose={() => setModal(false)}
        title={update ? "Update Category" : "Add New Category"}
        onOk={createNewCategory}
        loading={buttonloading}
      >
        <div
          className="col"
          style={{
            marginTop: 10,
          }}
        >
          <CustomInput
            name="Name"
            onChange={(e) =>
              setNewCategory((prev) => ({ ...prev, name: e.target.value }))
            }
            value={newCategory.name}
          />
          <CustomInput
            name="Position"
            onChange={(e) =>
              setNewCategory((prev) => ({ ...prev, position: e.target.value }))
            }
            value={newCategory.position}
          />
        </div>
      </Modal>
    </>
  );
};

export default Categories;
